
export default {
  drawer: true,
  notifications: [],
  notificationsNumber: '',
}
